import { ApplicationError } from './application.error';

export class InvalidCredentialsError extends ApplicationError {
  constructor(message: string = 'Correo electrónico o contraseña incorrectos.') {
    super(message, 'INVALID_CREDENTIALS');
  }
}
